export const IdinLogo = ({ className = '', height = '21' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            // width="107.98mm"
            height={height}
            viewBox="0 0 306.09 269.83"
            className={`${className}`}>
            <path
                style={{ fill: '#fff' }}
                d="M0,20V249.83a20,20,0,0,0,20,20H157.32c103.77,0,148.77-58.12,148.77-135.18C306.09,57.89,261.09,0,157.32,0H20A20,20,0,0,0,0,20Z"
            />
            <path d="M157.29,251.46H37.86a19.22,19.22,0,0,1-19.2-19.2V37.57a19.22,19.22,0,0,1,19.2-19.2H157.29c113.27,0,130.19,72.85,130.19,116.28C287.48,210,241.24,251.46,157.29,251.46ZM37.86,24.77a12.82,12.82,0,0,0-12.81,12.8V232.26a12.82,12.82,0,0,0,12.81,12.8H157.29c79.82,0,123.79-39.21,123.79-110.41,0-95.6-77.56-109.88-123.79-109.88Z" />
            <path
                style={{ fill: '#00b0f0' }}
                d="M91.88,56.43V226.2h73.9c67.14,0,96.25-37.94,96.25-91.46,0-51.27-29.11-91.11-96.25-91.11h-61.1A12.8,12.8,0,0,0,91.88,56.43Z"
            />
            <polygon
                style={{ fill: '#fff' }}
                points="168.27 111.86 185.2 139.07 185.31 139.07 185.31 111.86 193.66 111.86 193.66 152.41 184.74 152.41 167.87 125.26 167.76 125.26 167.76 152.41 159.41 152.41 159.41 111.86 168.27 111.86"
            />
            <rect
                style={{ fill: '#fff' }}
                x="142.51"
                y="111.86"
                width="8.92"
                height="40.55"
            />
            <path
                style={{ fill: '#fff' }}
                d="M134.91,123.11a17.26,17.26,0,0,0-3.87-6.25,15.64,15.64,0,0,0-5.85-3.75,20.9,20.9,0,0,0-7.29-1.25H100.4v40.55h17.5a19.43,19.43,0,0,0,8.09-1.56,16.14,16.14,0,0,0,5.74-4.29,18,18,0,0,0,3.43-6.47,28,28,0,0,0,1.14-8.18A25.44,25.44,0,0,0,134.91,123.11Zm-8.38,15.33a10.52,10.52,0,0,1-2.27,3.78,8.28,8.28,0,0,1-3.24,2.07,11.36,11.36,0,0,1-3.75.63h-8V119.36h6.36a14.51,14.51,0,0,1,5.54.93,8.83,8.83,0,0,1,3.61,2.7,11,11,0,0,1,2,4.23,24.14,24.14,0,0,1,.59,5.54A16.54,16.54,0,0,1,126.53,138.44Z"
            />
            <path
                style={{ fill: '#000' }}
                d="M58.48,161.57h0a14.17,14.17,0,0,1,14.17,14.17V226.2a0,0,0,0,1,0,0h0A28.35,28.35,0,0,1,44.3,197.85V175.74A14.17,14.17,0,0,1,58.48,161.57Z"
            />
            <circle style={{ fill: '#000' }} cx="58.48" cy="132.1" r="18.71" />
        </svg>
    );
};
